module.exports = __webpack_public_path__ + "media/images/team5-3cd16cfe.jpg";